import React from 'react';
import {
  ArrowUpRight, CircleDot, Blend, Refrigerator, WashingMachine,
  Snowflake, Wind, Utensils,
} from 'lucide-react';
import { innovativeSolutions } from '../mock';
import useReveal from '../hooks/useReveal';

const iconMap = {
  CircleDot, Blender: Blend, Refrigerator, WashingMachine, Snowflake, Wind, Utensils,
};

const Solutions = () => {
  useReveal();
  return (
    <section
      id="solutions"
      className="py-16 lg:py-24"
      style={{ background: 'linear-gradient(180deg, #E9D6C1 0%, #F7F4EA 100%)' }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12 reveal">
          <div className="text-[11px] uppercase tracking-[0.32em] font-semibold text-[#F58220] mb-4">
            Lifestyle & Innovation
          </div>
          <h2 className="h-display uppercase text-[40px] md:text-[64px] text-[#1a1410]">
            Innovative <span className="text-[#F58220]">Solutions</span>
          </h2>
          <p className="mt-5 text-[15px] text-[#4D4D4D]">
            From house to distinguished prestige home.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
          {innovativeSolutions.map((p, i) => {
            const Icon = iconMap[p.icon] || CircleDot;
            return (
              <div
                key={p.id}
                className="reveal group relative rounded-2xl overflow-hidden bg-white border border-[#E9D6C1] card-lift"
                style={{ transitionDelay: `${i * 70}ms` }}
              >
                <div className="aspect-[4/3] relative overflow-hidden flex items-center justify-center"
                  style={{ background: 'radial-gradient(circle at 50% 40%, #FFF6EA 0%, #F7F4EA 60%, #E9D6C1 100%)' }}
                >
                  {/* concentric halo */}
                  <div className="absolute w-32 h-32 rounded-full border border-[#F58220]/15" />
                  <div className="absolute w-44 h-44 rounded-full border border-[#F58220]/10" />
                  <div className="absolute w-56 h-56 rounded-full border border-[#F58220]/5" />
                  <div className="relative w-20 h-20 rounded-2xl bg-[#1a1410] flex items-center justify-center group-hover:scale-110 group-hover:-rotate-6 transition-transform duration-500">
                    <Icon className="w-10 h-10 text-[#F58220]" strokeWidth={1.5} />
                  </div>
                </div>
                <div className="p-5 flex items-center justify-between">
                  <div>
                    <div className="font-semibold text-[16px] text-[#1a1410]">{p.name}</div>
                    <div className="text-[10px] uppercase tracking-[0.22em] font-semibold text-[#8E8E8E] mt-1">
                      Solution
                    </div>
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-[#F58220] group-hover:rotate-12 transition-transform duration-500" />
                </div>
                <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-[#F58220] text-[10px] uppercase tracking-[0.2em] font-bold text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  Explore
                </div>
              </div>
            );
          })}
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="reveal group rounded-2xl bg-[#4D4D4D] text-[#F7F4EA] flex flex-col items-start justify-end p-6 aspect-[4/3] card-lift"
          >
            <div className="text-[11px] uppercase tracking-[0.3em] font-semibold text-[#F58220] mb-2">Explore</div>
            <div className="h-display uppercase text-[22px]">View More</div>
            <div className="mt-4 w-10 h-10 rounded-full bg-[#F58220]/25 flex items-center justify-center group-hover:bg-[#F58220] transition-colors duration-500">
              <ArrowUpRight className="w-4 h-4 text-[#F58220] group-hover:text-white" />
            </div>
          </a>
        </div>

        <div className="mt-16 flex justify-center reveal">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="btn-primary px-8 py-3.5 rounded-full text-[11px] uppercase tracking-[0.24em]"
          >
            Visit our Store
          </a>
        </div>
      </div>
    </section>
  );
};

export default Solutions;
